(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(43051);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Button = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, _theme = param.theme, theme = _theme === void 0 ? "primary" : _theme, _type = param.type, type = _type === void 0 ? "default" : _type, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex cursor-pointer select-none items-center justify-center rounded-full ".concat(theme === "dark" ? "".concat(type === "outline" ? "border-[2px] border-[#292939] text-[#292939] hover:bg-[#292939] hover:text-white" : "bg-[#292939] text-white hover:bg-[#292939]/90") : "".concat(type === "outline" ? "border-[2px] border-primary text-primary hover:opacity-80" : "bg-primary text-white hover:bg-primary/90"), " h-[56px]  w-[242px] text-sm transition-all  ").concat(className),
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 43051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-div-100vh/dist/esm/index.js
var esm = __webpack_require__(66409);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/form/components/common/icons.tsx
var icons = __webpack_require__(85119);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useAlchemyBadge.ts

function useAlchemyBadge(id) {
    var logBadgeClick = function logBadgeClick() {
        fetch("".concat(ALCHEMY_ANALYTICS_URL, "/badge-click"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                badge_id: id
            })
        });
        // @ts-ignore
        window.open(ALCHEMY_URL, "_blank").focus();
    };
    var logBadgeView = function logBadgeView() {
        fetch("".concat(ALCHEMY_ANALYTICS_URL, "/badge-view"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                badge_id: id
            })
        });
    };
    var isBadgeInViewpoint = function isBadgeInViewpoint(bounding) {
        return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
    };
    var ALCHEMY_URL = "https://alchemyapi.io/?r=badge:".concat(id);
    var ALCHEMY_ANALYTICS_URL = "https://analytics.alchemyapi.io/analytics";
    (0,react.useEffect)(function() {
        var intervalId = setInterval(function() {
            var badge = document.getElementById("badge-button");
            if (badge && isBadgeInViewpoint(badge.getBoundingClientRect())) {
                logBadgeView();
                clearInterval(intervalId);
            }
        }, 2000);
        return function() {
            clearInterval(intervalId);
        };
    }, []);
    return {
        logBadgeClick: logBadgeClick
    };
}

;// CONCATENATED MODULE: ./src/components/common/Footer.tsx




function About() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[22px] font-bold",
                children: "ABOUT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://docs.karatdao.com",
                target: "_blank",
                className: "action mb-[14px] block !text-primary",
                rel: "noopener noreferrer",
                children: "Documents"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "action mb-[14px] block !text-primary",
                href: "https://karatdao.notion.site/KaratDAO-Job-Board-e23467773a3148b69002a0ed84683546",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "Careers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "action mb-[14px] block !text-primary",
                href: "https://docs.karatdao.com/team-directory",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "Team"
            })
        ]
    });
}
function Support() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[22px] font-bold",
                children: "SUPPORT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "mailto:info@karatdao.com",
                className: "action mb-[14px] block !text-primary",
                children: "Contact Us"
            })
        ]
    });
}
function Community() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[22px] font-bold",
                children: "COMMUNITY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "action mb-5 flex items-center !text-primary",
                target: "_blank",
                href: "https://discord.gg/fcvFtkfrRA",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DiscordIcon */.D7, {
                        className: "w-5 h-5 fill-primary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: "Discord"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "action mb-5 flex items-center !text-primary",
                target: "_blank",
                href: "https://twitter.com/KaratDAO",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TwitterIcon */.Zm, {
                        className: "w-5 h-5 fill-primary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: "Twitter"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "action mb-5 flex items-center !text-primary",
                target: "_blank",
                href: "https://medium.com/@karatdao",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MediumIcon */.OW, {
                        className: "w-5 h-5 fill-primary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: "Medium"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "action mb-5 flex items-center !text-primary",
                target: "_blank",
                href: "https://trend3.io/Karatdao",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/trend3.png",
                        width: 20,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: "ReadON"
                    })
                ]
            })
        ]
    });
}
var Footer = function() {
    var logBadgeClick = useAlchemyBadge("zg4ODQ5Nzg0NTE1M").logBadgeClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-wrap justify-between p-10 sm:py-14 sm:px-[120px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-5 text-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/airdrop_assets/karatdaoLogo.svg",
                            width: 150,
                            height: 40,
                            alt: "logo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 max-w-[334px]",
                            children: "Revolutionize and simplify how projects & individuals are able to utilize the vast network of on-chain data."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-4 mb-6",
                            children: [
                                new Date().getFullYear(),
                                " KaratDAO. All Rights Reserved"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                onClick: logBadgeClick,
                                id: "badge-button",
                                style: {
                                    width: 178,
                                    height: 39
                                },
                                src: "https://static.alchemyapi.io/images/marketing/badgeLight.png",
                                alt: "Alchemy Supercharged"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden grid-cols-3 gap-5 sm:grid md:gap-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Support, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Community, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between w-full mt-10 sm:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Support, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Community, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var common_Footer = (Footer);

// EXTERNAL MODULE: ./src/components/common/Nav.tsx + 4 modules
var Nav = __webpack_require__(27356);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/homepage/FeaturesIntro.tsx



var BridgeIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.5 4C18.7449 4.00003 18.9813 4.08996 19.1644 4.25272C19.3474 4.41547 19.4643 4.63975 19.493 4.883L19.5 5V6.565L19.616 6.666L19.893 6.897C19.943 6.939 19.997 6.981 20.051 7.023C20.584 7.438 21.228 7.855 21.816 8.051C21.9406 8.0925 22.0558 8.15814 22.1551 8.24417C22.2544 8.3302 22.3357 8.43494 22.3945 8.5524C22.4533 8.66987 22.4883 8.79776 22.4977 8.92878C22.507 9.0598 22.4905 9.19138 22.449 9.316C22.4075 9.44062 22.3419 9.55585 22.2558 9.65511C22.1698 9.75437 22.0651 9.83571 21.9476 9.89449C21.8301 9.95327 21.7022 9.98834 21.5712 9.99769C21.4402 10.007 21.3086 9.9905 21.184 9.949C20.6821 9.77383 20.2022 9.54093 19.754 9.255L19.5 9.091V14H22.5C22.7549 14.0003 23 14.0979 23.1854 14.2728C23.3707 14.4478 23.4822 14.687 23.4972 14.9414C23.5121 15.1958 23.4293 15.4464 23.2657 15.6418C23.1021 15.8373 22.8701 15.9629 22.617 15.993L22.5 16H19.5V19C19.4997 19.2549 19.4021 19.5 19.2271 19.6854C19.0522 19.8707 18.813 19.9822 18.5586 19.9972C18.3042 20.0121 18.0536 19.9293 17.8582 19.7657C17.6627 19.6021 17.5371 19.3701 17.507 19.117L17.5 19V16H7.49999V19C7.49971 19.2549 7.40211 19.5 7.22714 19.6854C7.05217 19.8707 6.81304 19.9822 6.5586 19.9972C6.30415 20.0121 6.05361 19.9293 5.85816 19.7657C5.66271 19.6021 5.53709 19.3701 5.50699 19.117L5.49999 19V16H2.49999C2.24511 15.9997 1.99996 15.9021 1.81462 15.7272C1.62929 15.5522 1.51776 15.313 1.50282 15.0586C1.48788 14.8042 1.57067 14.5536 1.73426 14.3582C1.89785 14.1627 2.12989 14.0371 2.38299 14.007L2.49999 14H5.49999V9.09C5.00399 9.421 4.42199 9.747 3.81599 9.949C3.69137 9.9905 3.55979 10.007 3.42877 9.99769C3.29775 9.98834 3.16986 9.95327 3.05239 9.89449C2.81516 9.77578 2.6348 9.56769 2.55099 9.316C2.46718 9.06431 2.48679 8.78964 2.6055 8.5524C2.72421 8.31517 2.9323 8.13481 3.18399 8.051C3.77199 7.855 4.41599 7.438 4.94899 7.023L5.10699 6.897L5.38399 6.666L5.49999 6.565V5C5.50027 4.74512 5.59787 4.49997 5.77284 4.31463C5.94781 4.1293 6.18694 4.01777 6.44139 4.00283C6.69583 3.98789 6.94637 4.07067 7.14182 4.23426C7.33728 4.39786 7.46289 4.6299 7.49299 4.883L7.49999 5V6.722C7.76266 7.09774 8.07826 7.43354 8.43699 7.719C9.20999 8.338 10.493 9 12.5 9C14.507 9 15.79 8.338 16.563 7.72C16.956 7.405 17.227 7.094 17.395 6.869L17.5 6.722V5C17.5 4.73478 17.6053 4.48043 17.7929 4.29289C17.9804 4.10536 18.2348 4 18.5 4ZM17.5 9.517C16.9844 9.88396 16.4246 10.1847 15.834 10.412L15.5 10.533V14H17.5V9.517ZM13.5 10.953C12.9426 11.0064 12.3818 11.0151 11.823 10.979L11.5 10.953V14H13.5V10.953ZM7.49999 9.517V14H9.49999V10.533L9.16599 10.413C8.66547 10.2197 8.1868 9.97402 7.73799 9.68L7.49999 9.517Z",
            fill: "white"
        })
    }));
};
var AuthIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.5 19H14.5M14.5 19V15M14.5 19L19.5 14M5 7.504L1.5 5.504M1.5 5.504L3.5 2M1.5 5.504L8.33 3.634M2.5 14L6.5 13M6.5 13L7.5 17M6.5 13L3 19M19.5 3L19 7M19 7L15 6.5M19 7L14.5 1.5",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var ExchangeIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM12.5 9H8.5V11H17.5L12.5 6V9ZM7.5 13L12.5 18V15H16.5V13H7.5Z",
            fill: "white"
        })
    });
};
var CoinIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 14C11.8137 14 14.5 11.3137 14.5 8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.59 10.37C19.5353 10.7224 20.3765 11.3075 21.0358 12.0712C21.695 12.8349 22.1511 13.7524 22.3617 14.7391C22.5724 15.7257 22.5309 16.7495 22.241 17.7158C21.9512 18.6822 21.4223 19.5598 20.7034 20.2676C19.9845 20.9754 19.0987 21.4905 18.128 21.7652C17.1572 22.04 16.1329 22.0655 15.1497 21.8395C14.1665 21.6134 13.2561 21.1431 12.5028 20.472C11.7495 19.8009 11.1776 18.9507 10.84 18M7.5 6H8.5V10",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.21 13.8799L17.91 14.5899L15.09 17.4099",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var SecureIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21.5 18H15.32C15.1707 17.5806 14.9299 17.1997 14.6151 16.8849C14.3003 16.5701 13.9194 16.3293 13.5 16.18V13H20.5C20.7652 13 21.0196 12.8946 21.2071 12.7071C21.3946 12.5196 21.5 12.2652 21.5 12C21.5 11.7348 21.3946 11.4804 21.2071 11.2929C21.0196 11.1054 20.7652 11 20.5 11H19.5V5C19.5 4.20435 19.1839 3.44129 18.6213 2.87868C18.0587 2.31607 17.2956 2 16.5 2H8.5C7.70435 2 6.94129 2.31607 6.37868 2.87868C5.81607 3.44129 5.5 4.20435 5.5 5V11H4.5C4.23478 11 3.98043 11.1054 3.79289 11.2929C3.60536 11.4804 3.5 11.7348 3.5 12C3.5 12.2652 3.60536 12.5196 3.79289 12.7071C3.98043 12.8946 4.23478 13 4.5 13H11.5V16.18C11.0806 16.3293 10.6997 16.5701 10.3849 16.8849C10.0701 17.1997 9.82932 17.5806 9.68 18H3.5C3.23478 18 2.98043 18.1054 2.79289 18.2929C2.60536 18.4804 2.5 18.7348 2.5 19C2.5 19.2652 2.60536 19.5196 2.79289 19.7071C2.98043 19.8946 3.23478 20 3.5 20H9.68C9.8902 20.5792 10.2736 21.0795 10.7782 21.4332C11.2827 21.7868 11.8839 21.9765 12.5 21.9765C13.1161 21.9765 13.7173 21.7868 14.2218 21.4332C14.7264 21.0795 15.1098 20.5792 15.32 20H21.5C21.7652 20 22.0196 19.8946 22.2071 19.7071C22.3946 19.5196 22.5 19.2652 22.5 19C22.5 18.7348 22.3946 18.4804 22.2071 18.2929C22.0196 18.1054 21.7652 18 21.5 18ZM7.5 11V5C7.5 4.73478 7.60536 4.48043 7.79289 4.29289C7.98043 4.10536 8.23478 4 8.5 4H16.5C16.7652 4 17.0196 4.10536 17.2071 4.29289C17.3946 4.48043 17.5 4.73478 17.5 5V11H7.5ZM12.5 20C12.3022 20 12.1089 19.9414 11.9444 19.8315C11.78 19.7216 11.6518 19.5654 11.5761 19.3827C11.5004 19.2 11.4806 18.9989 11.5192 18.8049C11.5578 18.6109 11.653 18.4327 11.7929 18.2929C11.9327 18.153 12.1109 18.0578 12.3049 18.0192C12.4989 17.9806 12.7 18.0004 12.8827 18.0761C13.0654 18.1518 13.2216 18.28 13.3315 18.4444C13.4414 18.6089 13.5 18.8022 13.5 19C13.5 19.2652 13.3946 19.5196 13.2071 19.7071C13.0196 19.8946 12.7652 20 12.5 20Z",
            fill: "white"
        })
    });
};
var KeyIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.5 16C11.5 16.6 11.1 17 10.5 17C9.9 17 9.5 16.6 9.5 16C9.5 15.4 9.9 15 10.5 15C11.1 15 11.5 15.4 11.5 16ZM20.5 8V20C20.5 21.1 19.6 22 18.5 22H6.5C5.4 22 4.5 21.1 4.5 20V4C4.5 2.9 5.4 2 6.5 2H14.5M18.5 15H13.3C12.7 13.4 11 12.6 9.5 13.2C7.9 13.8 7.1 15.5 7.7 17C8.3 18.5 10 19.4 11.5 18.8C12.4 18.5 13 17.8 13.3 17H14.5V19H16.5V17H18.5M19 9L13.5 3.5V9H19Z",
            fill: "white"
        })
    });
};
var featureList = [
    {
        Icon: BridgeIcon,
        title: "Bridge Web2 data and Web3 ",
        desc: "Create verifiable credentials of your Web2 data"
    },
    {
        Icon: AuthIcon,
        title: "Authorization",
        desc: "Authorize your data with confidence. Similar to the oAuth Flow"
    },
    {
        Icon: ExchangeIcon,
        title: "Data Sharing and Trading",
        desc: "Exchange values with the Network by providing data and interacting"
    },
    {
        Icon: CoinIcon,
        title: "Dual-NFT Token Design",
        desc: "Two NFT roles, one network"
    },
    {
        Icon: SecureIcon,
        title: "Secured by MPC",
        desc: "Access control secured by smart contract and MPC together"
    },
    {
        Icon: KeyIcon,
        title: "Sign in with Ethereum",
        desc: "Data ownership, protected with your Ethereum wallet"
    }, 
];
var FeaturesIntro = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "layout-content bg-[#202020] py-12 sm:py-20 px-8 sm:px-[143px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "layout-block grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-3 sm:gap-x-[140px] sm:gap-y-20 text-white",
            children: featureList.map(function(feature, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sm:text-headerL font-semibold mt-1 h-[32px] sm:h-auto",
                            children: feature.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "opacity-[0.85] mt-4 leading-tight",
                            children: feature.desc
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var homepage_FeaturesIntro = (FeaturesIntro);

// EXTERNAL MODULE: ./src/components/homepage/Button.tsx
var Button = __webpack_require__(70548);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/homepage/FormIntro.tsx



var FormIntro = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selection:text-fill-white font-extrabold text-[40px] sm:text-[56px] leading-none w-[341px] sm:w-[643px] text-center",
                        style: {
                            background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        },
                        children: "Web3 growth hacking with Karat dApps"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4 sm:whitespace-pre-line text-center px-14 sm:px-0",
                        children: "Grow your community with our dApps.\nPowered by Web2 data from Karat network that’s coming soon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "form-anchor",
                className: "layout-block relative z-[4] block overflow-visible px-5 py-5 sm:px-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-[3] mb-[9vh] mt-14 flex h-[640px] w-full flex-wrap items-center rounded-lg shadow-card1 sm:h-auto overflow-hidden",
                        style: {
                            background: "linear-gradient(180deg, #9AC0FC 0%, #FFFFFF 100%)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-1 items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-6 pt-6 lg:mx-[60px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pr-5 text-2xl font-bold text-dark1",
                                            children: "Karat Form"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-2 pr-4 font-normal text-dark1 w-[330px]",
                                            children: "The simplest way to collect wallet addresses and social accounts for your NFT whitelist, raffle, and AMA."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-primary font-medium mt-2 action mb-7 ",
                                            children: "Learn more"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-track": "home_get_start",
                                            "data-track-params": '{"position": "create"}',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/dashboard/forms/start_create",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    theme: "dark",
                                                    children: "Get started for free"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mt-6 block ml-10 sm:hidden",
                                src: "/airdrop_assets/homepage/form-step-1.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 relative mx-4 mr-[10%] hidden sm:block h-[425px] w-[480px]",
                                style: {
                                    backgroundImage: 'url("/airdrop_assets/homepage/form-step-1.png")',
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center -25px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "analytics-anchor",
                        className: " z-[2] mb-[2vh] mt-[-7vh] flex h-[640px] w-full flex-wrap items-center rounded-lg shadow-card1 sm:h-auto overflow-hidden",
                        style: {
                            background: "linear-gradient(180deg, #9AC0FC 0%, #FFFFFF 100%)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-1 items-center ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-6 pt-6 lg:mx-[60px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-2xl font-bold text-dark1",
                                            children: "Wallet Dashboard"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-2 font-normal text-dark1 w-[330px]",
                                            children: "Explore in-depth insights with your customized wallet list, Galaxy campaign, or NFT"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-primary font-medium mt-2 action mb-7 ",
                                            children: "Learn more"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-track": "home_get_start",
                                            "data-track-params": '{"position": "response"}',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/dashboard/analytics",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    theme: "dark",
                                                    children: "Get started for free"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mt-6 block pb-3 sm:hidden ml-10",
                                src: "/airdrop_assets/homepage/m-form-step-2.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 relative hidden sm:block h-[385px] w-[520px] mr-[10%]",
                                style: {
                                    backgroundImage: 'url("/airdrop_assets/homepage/form-step-2.png")',
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "airdrops-anchor",
                        className: "z-[1] flex h-[640px] w-full flex-wrap items-center rounded-lg shadow-card1 sm:h-auto overflow-hidden",
                        style: {
                            background: "linear-gradient(180deg, #9AC0FC 0%, #FFFFFF 100%)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-1 items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-6 pt-6 lg:mx-[60px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-2xl font-bold text-dark1",
                                            children: "Airdrop Launchpad"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-2 font-normal text-dark1 w-[330px]",
                                            children: "Send token or NFT airdrops to your community and potential audiences"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-primary font-medium mt-2 action mb-7 ",
                                            children: "Learn more"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-track": "home_get_start",
                                            "data-track-params": '{"position": "reward"}',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/dashboard/airdrops",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    theme: "dark",
                                                    children: "Get started for free"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mt-6 block sm:hidden ml-5",
                                src: "/airdrop_assets/homepage/m-form-step-3.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 relative hidden h-[210px] w-[310px] sm:block md:h-[405px] md:w-[550px] mr-[10%]",
                                style: {
                                    backgroundImage: 'url("/airdrop_assets/homepage/form-step-3-1.png")',
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_FormIntro = (FormIntro);

;// CONCATENATED MODULE: ./src/components/homepage/InfiniteLoopScroll.tsx

var InfiniteLoopSlider = function(param) {
    var children = param.children, duration = param.duration, _direction = param.direction, direction = _direction === void 0 ? "normal" : _direction, _className = param.className, className = _className === void 0 ? "" : _className, _animation = param.animation, animation = _animation === void 0 ? "loop" : _animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-fit ".concat(className),
        style: {
            animationName: animation,
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
            animationDirection: direction,
            animationDuration: duration
        },
        children: [
            children,
            children
        ]
    });
};
/* harmony default export */ var InfiniteLoopScroll = (InfiniteLoopSlider);

;// CONCATENATED MODULE: ./src/components/homepage/Partners.tsx


var partners = [
    "ANKR.svg",
    "Delysium.svg",
    "HuobiGlobal.svg",
    "HYPEX.svg",
    "KuCoinCommunity.svg",
    "KuCoinVentures.svg",
    "LAAGLabs.svg",
    "MetaForce.svg",
    "Nswap.svg",
    "367.svg",
    "377.svg", 
];
var Partners = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-block layout-content px-5 py-0 sm:py-10 sm:px-28",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-9 text-[28px] font-bold",
                children: "Our ecosystem partners"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto flex flex-shrink-0 flex-col overflow-hidden sm:w-[65vw]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteLoopScroll, {
                        duration: "10000ms",
                        children: partners.map(function(partner) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/airdrop_assets/home-page-img/SupportedBrands/".concat(partner),
                                className: "h-20 w-20"
                            }, partner);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-none absolute inset-0",
                        style: {
                            background: "linear-gradient(90deg, #ffffff, transparent 30%, transparent 70%, #ffffff)"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_Partners = (Partners);

;// CONCATENATED MODULE: ./src/components/homepage/DataOwnship.tsx

var DataOwnship = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden sm:flex layout-block flex-col items-center py-[120px] px-[186px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "selection:text-fill-white font-extrabold text-[56px] leading-none ",
                        style: {
                            background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        },
                        children: [
                            "Future of data ownership",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-medium text-dark2 mt-4",
                        children: "Bridge the gap between Web2 data and Web3 addresses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mt-10 rounded-[20px] bg-white pl-20 flex items-center",
                        style: {
                            filter: "drop-shadow(0px 4px 25px #EEF4FC)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[340px] translate-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "uppercase font-bold text-dark2",
                                        children: "For Projects"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold text-dark1 text-[28px] mt-4 leading-[37px]",
                                        children: "Request insights from Karat Network"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark1 leading-[24px]",
                                        children: "Understand the people behind the wallets"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 flex items-center -ml-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[397px] w-full bg-no-repeat bg-cover z-10",
                                    style: {
                                        backgroundImage: 'url("/assets/home/ownership-1.png")',
                                        backgroundPosition: "-30px 0px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mt-6 rounded-[20px] bg-white pr-20 flex items-center",
                        style: {
                            filter: "drop-shadow(0px 4px 25px #EEF4FC)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/home/ownership-2.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[340px] -translate-x-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "uppercase font-bold text-dark2",
                                        children: "For Users"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold text-dark1 text-[28px] mt-4 leading-[37px]",
                                        children: "Authorize your data with confidence"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark1 leading-[24px]",
                                        children: "Exchange values with the network by providing data and interacting"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "layout-content flex sm:hidden flex-col items-center py-[85px] px-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "selection:text-fill-white font-extrabold text-[40px] leading-none text-center",
                        style: {
                            background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        },
                        children: [
                            "Future of data ownership",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-medium text-dark2 mt-4 text-center",
                        children: "Bridge the gap between Web2 data and Web3 addresses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mt-10 rounded-[6px] bg-white flex flex-col",
                        style: {
                            boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-6 pt-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "uppercase font-bold text-dark2 text-xs",
                                        children: "For Projects"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold text-dark1 text-[20px] mt-4 leading-[27px]",
                                        children: "Request insights from Karat Network"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark1 leading-[19px] mt-2 text-sm",
                                        children: "Understand the people behind the wallets"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 -mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/home/ownership-m-1.png"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mt-6 rounded-[6px] bg-white flex flex-col",
                        style: {
                            boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-6 pt-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "uppercase font-bold text-dark2 text-xs",
                                        children: "For Users"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-bold text-dark1 text-[20px] mt-4 leading-[27px]",
                                        children: "Authorize your data with confidence"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark1 leading-[19px] mt-2 text-sm",
                                        children: "Exchange values with the network by providing data and interacting"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 -mt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/home/ownership-m-2.png"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_DataOwnship = (DataOwnship);

// EXTERNAL MODULE: ./node_modules/scrollmonitor/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(96474);
;// CONCATENATED MODULE: ./src/components/homepage/ChooseRole.tsx



var rolesLink = "https://docs.karatdao.com/roles";
var ChooseRole = function() {
    (0,react.useEffect)(function() {
        var containerMonitor = dist_module/* default.createContainer */.ZP.createContainer(document.getElementById("container"));
        var validatorElement = document.getElementById("validator");
        var verifierElement = document.getElementById("verifier");
        if (!validatorElement) {
            return;
        }
        var slideListener = function(evt, watcher) {
            if (!watcher) {
                return;
            }
            if (watcher.isBelowViewport) {
                if (watcher.isInViewport) {
                    watcher.watchItem.classList.add("animate__animated", "animate__slideInUp", "!visible");
                } else {
                    watcher.watchItem.classList.remove("animate__animated", "animate__slideInUp", "visible");
                }
            }
        };
        var validator = containerMonitor.create(validatorElement);
        var slideRightListener = function(_, watcher) {
            if (!watcher) {
                return;
            }
            if (watcher.isBelowViewport) {
                if (watcher.isInViewport) {
                    validatorElement.classList.add("animate__animated", "animate__fadeInRight", "animate__faster", "!visible");
                } else {
                    validatorElement.classList.remove("animate__animated", "animate__fadeInRight", "animate__faster", "!visible");
                }
            }
        };
        validator.on("visibilityChange", slideRightListener);
        var verifier = containerMonitor.create(verifierElement);
        var slideLeftListener = function(_, watcher) {
            if (!watcher) {
                return;
            }
            if (watcher.isBelowViewport) {
                if (watcher.isInViewport) {
                    verifierElement.classList.add("animate__animated", "animate__fadeInLeft", "animate__faster", "!visible");
                } else {
                    verifierElement.classList.remove("verifierElement", "animate__fadeInLeft", "animate__faster", "!visible");
                }
            }
        };
        verifier.on("visibilityChange", slideLeftListener);
        return function() {
            verifier.off("visibilityChange", slideLeftListener);
            validator.off("visibilityChange", slideRightListener);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-content flex flex-col items-center py-[120px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "selection:text-fill-white font-extrabold text-[40px] sm:text-[56px] leading-none max-w-[643px] text-center",
                style: {
                    background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent"
                },
                children: "Choose your role and participate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center whitespace-pre-line mt-4 font-medium text-dark2",
                children: "Two NFTs, One Ecosystem\nNetwork powered by dual-NFT tokenomic design"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden sm:flex justify-center w-full mt-[52px] z-10",
                style: {
                    background: "linear-gradient(180deg, rgba(244, 219, 140, 0) 0%, rgba(244, 219, 140, 0.1) 54.69%, rgba(244, 219, 140, 0) 100%)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-[#12162B] -mr-2 rounded-lg px-6 h-[28vw] flex-shrink-0 w-[27vw] flex flex-col items-center justify-center mt-[1.5vw] translate-x-[100%]",
                        id: "validator",
                        style: {
                            boxShadow: "inset 10px 4px 19px rgba(248, 225, 225, 0.3)",
                            backdropFilter: "blur(2px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white text-2xl font-semibold",
                                children: "Validator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#E0D8D8] whitespace-pre-line mt-4 text-center text-sm lg:text-base",
                                children: "・ Pay to mint\n・ Tradable\n・ Backed by referral number\n・ For influential leaders"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "mt-6 text-brand2 font-semibold action",
                                href: rolesLink,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Learn more"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden sm:block z-10 w-[29vw] flex-shrink-0",
                        style: {
                            filter: "drop-shadow(0px 4px 40px #E0E0FB)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                filter: "drop-shadow(2px 4px 16px rgba(0, 0, 0, 0.05))"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/network/network-role.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "verifier",
                        className: "bg-[#12162B] -ml-2 rounded-lg px-6 h-[28vw] flex-shrink-0 w-[27vw] hidden sm:flex flex-col items-center justify-center mt-[6.5vw] -translate-x-[100%]",
                        style: {
                            boxShadow: "inset 10px 4px 19px rgba(248, 225, 225, 0.3)",
                            backdropFilter: "blur(2px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white text-2xl font-semibold",
                                children: "Karat ID"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#E0D8D8] mt-4 text-center whitespace-pre-line text-sm lg:text-base",
                                children: "・ Mint fee 5U\n・ SoulBound Token\n・ Backed by your credentials\n・ For users"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "mt-6 text-brand2 font-semibold action",
                                href: rolesLink,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Learn more"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:hidden bg-[#12162B] w-[72%] rounded-lg p-8 pb-12 flex-shrink-0 flex flex-col items-center justify-center mt-10 -mb-2",
                style: {
                    boxShadow: "inset 10px 4px 19px rgba(248, 225, 225, 0.3)",
                    backdropFilter: "blur(2px)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-white font-semibold",
                        children: "Validator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#E0D8D8] whitespace-pre-line mt-4 text-center text-sm lg:text-base",
                        children: "・ Pay to mint\n・ Tradable\n・ Backed by referral number\n・ For influential leaders"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "mt-6 text-brand2 font-semibold action",
                        href: rolesLink,
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Learn more"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:hidden z-10 w-[81%] flex-shrink-0",
                style: {
                    filter: "drop-shadow(0px 4px 40px #E0E0FB)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        filter: "drop-shadow(2px 4px 16px rgba(0, 0, 0, 0.05))"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/network/network-role.png"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:hidden bg-[#12162B] rounded-lg p-8 pt-12 flex-shrink-0 w-[72%] flex flex-col items-center justify-center -mt-2 ",
                style: {
                    boxShadow: "inset 10px 4px 19px rgba(248, 225, 225, 0.3)",
                    backdropFilter: "blur(2px)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-white font-semibold",
                        children: "Karat ID"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#E0D8D8] mt-4 text-center whitespace-pre-line text-sm lg:text-base",
                        children: "・ Mint fee 5U\n・ SoulBound Token\n・ Backed by your credentials\n・ For users"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "mt-6 text-brand2 font-semibold action",
                        href: rolesLink,
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Learn more"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_ChooseRole = (ChooseRole);

;// CONCATENATED MODULE: ./src/components/homepage/Investors.tsx


var investors = [
    {
        img: "emurgo.png",
        style: {
            width: "147px",
            height: "36px"
        }
    },
    {
        img: "bitmart.png",
        style: {
            width: "166px",
            height: "124px"
        }
    },
    {
        img: "lc.png",
        style: {
            width: "144px",
            height: "65px"
        }
    },
    {
        img: "ms.png",
        style: {
            width: "192px",
            height: "55px"
        }
    },
    {
        img: "uc.png",
        style: {
            width: "223px",
            height: "44px"
        }
    },
    {
        img: "neo.png",
        style: {
            width: "106px",
            height: "33px"
        }
    }, 
];
var Investors = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-block layout-content px-5 py-[60px] sm:py-[100px] sm:px-28",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[32px] font-bold",
                children: "Our investors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto flex-shrink-0 flex-col overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteLoopScroll, {
                        duration: "18000ms",
                        animation: "loopInvestor",
                        className: "items-center",
                        children: investors.map(function(investor) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/home/investors/".concat(investor.img),
                                style: investor.style,
                                className: "mr-[60px]"
                            }, investor.img);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-none absolute inset-0",
                        style: {
                            background: "linear-gradient(90deg, #ffffff, transparent 20%, transparent 80%, #ffffff)"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_Investors = (Investors);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/homepage/Mission.tsx





var Mission = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var containerMonitor = dist_module/* default.createContainer */.ZP.createContainer(document.getElementById("container"));
        var rabbitElement = document.getElementById("rabbit");
        if (!rabbitElement) {
            return;
        }
        var rabbit = containerMonitor.create(rabbitElement);
        var slideRightListener = function(_, watcher) {
            if (!watcher) {
                return;
            }
            if (watcher.isBelowViewport) {
                if (watcher.isInViewport) {
                    rabbitElement.classList.add("animate__animated", "animate__slideInRight", "animate__slow", "!visible");
                } else {
                    rabbitElement.classList.remove("animate__animated", "animate__slideInRight", "animate__slow", "!visible");
                }
            }
        };
        rabbit.on("visibilityChange", slideRightListener);
        return function() {
            rabbit.off("visibilityChange", slideRightListener);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-content mb-[170px] mt-[20px] sm:mt-[80px] relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full h-[600px] sm:h-[410px] top-0 z-0",
                style: {
                    borderRadius: "1440px",
                    background: "linear-gradient(180deg, #ADB5FF 0%, #F8E1E0 100%)",
                    filter: "blur(92.1875px)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-network h-[521px] sm:h-[351px] bg-center bg-cover sm:flex flex-col sm:flex-row sm:items-center relative z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-11 sm:ml-[119px] flex-shrink-0 pt-[89px] sm:pt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white font-extrabold text-[40px] sm:text-[56px] w-[254px] sm:w-auto",
                                children: "Ready to join the mission?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "mt-6",
                                onClick: function() {
                                    router.push("/network/mission");
                                },
                                children: "Learn More"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        id: "rabbit",
                        src: "/airdrop_assets/homepage/rabbit.png",
                        className: "rabbit w-[214px] sm:w-[404px] mt-[25px] sm:-mt-[40px] sm:ml-10 ml-[125px] translate-x-full invisible"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_Mission = (Mission);

// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button_Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/carousel/esm/Carousel.js + 9 modules
var Carousel = __webpack_require__(52637);
// EXTERNAL MODULE: ./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js
var embla_carousel_autoplay_esm = __webpack_require__(22074);
;// CONCATENATED MODULE: ./src/components/homepage/ClaimerNFTPreview.tsx

var ClaimerNFTPreview_images = [
    "/assets/network/claimer/scientist.png",
    "/assets/network/claimer/engineer.png",
    "/assets/network/claimer/artist.png",
    "/assets/network/claimer/security.png",
    "/assets/network/claimer/doctor.png", 
];
var ClaimerNFTPreview = function ClaimerNFTPreview() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-5 gap-3 sm:gap-5 max-w-[1096px] w-[95vw] sm:w-[80vw]",
        children: ClaimerNFTPreview_images.map(function(img, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: img,
                className: "rounded-lg bg-transparent odd:mt-6",
                style: {
                    filter: "drop-shadow(2px 4px 20px rgba(173, 181, 255, 0.5))"
                },
                alt: ""
            }, index);
        })
    });
};
/* harmony default export */ var homepage_ClaimerNFTPreview = (ClaimerNFTPreview);

// EXTERNAL MODULE: ./src/components/common/icons.tsx
var common_icons = __webpack_require__(58163);
;// CONCATENATED MODULE: ./src/components/homepage/VCPreview.tsx




var DiscordIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "250",
        height: "135",
        viewBox: "0 0 250 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    filter: "url(#filter0_f_3619_22649)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M185.072 -15.8638C173.988 -21.0549 161.988 -24.8227 149.488 -26.9996C149.378 -27.0031 149.269 -26.9825 149.168 -26.9391C149.068 -26.8957 148.977 -26.8306 148.904 -26.7484C147.404 -23.9854 145.654 -20.3851 144.488 -17.6221C131.229 -19.6315 117.745 -19.6315 104.487 -17.6221C103.32 -20.4688 101.57 -23.9854 99.9864 -26.7484C99.9031 -26.9159 99.6531 -26.9996 99.4031 -26.9996C86.9027 -24.8227 74.9857 -21.0549 63.8188 -15.8638C63.7354 -15.8638 63.6521 -15.7801 63.5688 -15.6963C40.9015 18.381 34.6513 51.5373 37.7347 84.3587C37.7347 84.5262 37.8181 84.6937 37.9847 84.7774C52.9851 95.8295 67.4022 102.528 81.6526 106.965C81.9026 107.049 82.1526 106.965 82.2359 106.798C85.5694 102.193 88.5695 97.3366 91.1529 92.2292C91.3195 91.8943 91.1529 91.5593 90.8195 91.4756C86.0694 89.6336 81.5693 87.4567 77.1525 84.9448C76.8191 84.7774 76.8191 84.275 77.0691 84.0238C77.9858 83.354 78.9025 82.6004 79.8192 81.9306C79.9859 81.7632 80.2359 81.7632 80.4026 81.8469C109.07 94.9922 139.988 94.9922 168.322 81.8469C168.488 81.7632 168.738 81.7632 168.905 81.9306C169.822 82.6842 170.738 83.354 171.655 84.1076C171.988 84.3587 171.988 84.8611 171.572 85.0286C167.238 87.6241 162.655 89.7173 157.905 91.5593C157.571 91.6431 157.488 92.0617 157.571 92.3129C160.238 97.4203 163.238 102.277 166.488 106.882C166.738 106.965 166.988 107.049 167.238 106.965C181.572 102.528 195.989 95.8295 210.989 84.7774C211.156 84.6937 211.239 84.5262 211.239 84.3587C214.906 46.4299 205.156 13.5248 185.405 -15.6963C185.322 -15.7801 185.239 -15.8638 185.072 -15.8638ZM95.4863 64.3477C86.9027 64.3477 79.7359 56.3936 79.7359 46.5974C79.7359 36.8012 86.7361 28.847 95.4863 28.847C104.32 28.847 111.32 36.8849 111.237 46.5974C111.237 56.3936 104.237 64.3477 95.4863 64.3477ZM153.571 64.3477C144.988 64.3477 137.821 56.3936 137.821 46.5974C137.821 36.8012 144.821 28.847 153.571 28.847C162.405 28.847 169.405 36.8849 169.322 46.5974C169.322 56.3936 162.405 64.3477 153.571 64.3477Z",
                        fill: "url(#paint0_linear_3619_22649)"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f_3619_22649",
                        x: "33",
                        y: "-31",
                        width: "183",
                        height: "142",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "2",
                                result: "effect1_foregroundBlur_3619_22649"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3619_22649",
                        x1: "124.5",
                        y1: "-27",
                        x2: "124.5",
                        y2: "107",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#87B5FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#ADB5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var EmailIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "250",
        height: "135",
        viewBox: "0 0 250 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    filter: "url(#filter0_f_3619_22682)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M194.5 -34H54.5C44.875 -34 37.0875 -26.125 37.0875 -16.5L37 88.5C37 98.125 44.875 106 54.5 106H194.5C204.125 106 212 98.125 212 88.5V-16.5C212 -26.125 204.125 -34 194.5 -34ZM191 3.1875L129.137 41.8625C126.337 43.6125 122.663 43.6125 119.863 41.8625L58 3.1875C57.1226 2.69497 56.3543 2.02954 55.7415 1.23147C55.1288 0.433407 54.6843 -0.480693 54.435 -1.45551C54.1858 -2.43032 54.1369 -3.44557 54.2914 -4.43982C54.4458 -5.43406 54.8004 -6.38663 55.3337 -7.23987C55.867 -8.0931 56.5678 -8.82926 57.3939 -9.40379C58.2199 -9.97832 59.1539 -10.3793 60.1393 -10.5824C61.1248 -10.7855 62.1412 -10.7865 63.1271 -10.5855C64.113 -10.3844 65.0478 -9.98533 65.875 -9.4125L124.5 27.25L183.125 -9.4125C183.952 -9.98533 184.887 -10.3844 185.873 -10.5855C186.859 -10.7865 187.875 -10.7855 188.861 -10.5824C189.846 -10.3793 190.78 -9.97832 191.606 -9.40379C192.432 -8.82926 193.133 -8.0931 193.666 -7.23987C194.2 -6.38663 194.554 -5.43406 194.709 -4.43982C194.863 -3.44557 194.814 -2.43032 194.565 -1.45551C194.316 -0.480693 193.871 0.433407 193.258 1.23147C192.646 2.02954 191.877 2.69497 191 3.1875Z",
                        fill: "url(#paint0_linear_3619_22682)"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f_3619_22682",
                        x: "33",
                        y: "-38",
                        width: "183",
                        height: "148",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "2",
                                result: "effect1_foregroundBlur_3619_22682"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3619_22682",
                        x1: "124.5",
                        y1: "-34",
                        x2: "124.5",
                        y2: "106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#87B5FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#ADB5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var TwitterIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "250",
        height: "135",
        viewBox: "0 0 250 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    filter: "url(#filter0_f_4072_1741)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M212.5 -35.4956C206.064 -32.3685 199.151 -30.2557 191.883 -29.3007C199.382 -34.2211 204.993 -41.9654 207.668 -51.0883C200.622 -46.4993 192.911 -43.2692 184.87 -41.5383C179.462 -47.8695 172.3 -52.0659 164.494 -53.4761C156.689 -54.8862 148.677 -53.4311 141.703 -49.3368C134.729 -45.2424 129.183 -38.7378 125.926 -30.8329C122.669 -22.928 121.883 -14.065 123.69 -5.61993C109.414 -6.40594 95.4477 -10.4748 82.6984 -17.5625C69.9491 -24.6502 58.7013 -34.5983 49.6851 -46.7612C46.6022 -40.9298 44.8296 -34.1687 44.8296 -26.9681C44.8261 -20.4859 46.2819 -14.1031 49.0676 -8.38579C51.8533 -2.66852 55.8829 2.20637 60.7989 5.80634C55.0977 5.60741 49.5223 3.91816 44.5367 0.879183V1.38626C44.5361 10.4778 47.404 19.2895 52.6538 26.3263C57.9036 33.363 65.2118 38.1914 73.3385 39.9922C68.0497 41.5617 62.5048 41.7929 57.1226 40.6683C59.4154 48.491 63.8818 55.3316 69.8963 60.2326C75.9107 65.1335 83.1723 67.8494 90.6644 68C77.9462 78.9481 62.2393 84.8866 46.0704 84.8605C43.2063 84.8614 40.3446 84.678 37.5 84.3112C53.9123 95.8826 73.0175 102.024 92.5295 102C158.58 102 194.689 42.012 194.689 -10.0146C194.689 -11.7049 194.65 -13.4121 194.581 -15.1024C201.604 -20.6721 207.667 -27.569 212.485 -35.4702L212.5 -35.4956V-35.4956Z",
                        fill: "url(#paint0_linear_4072_1741)"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f_4072_1741",
                        x: "33.5",
                        y: "-58",
                        width: "183",
                        height: "164",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "2",
                                result: "effect1_foregroundBlur_4072_1741"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_4072_1741",
                        x1: "125",
                        y1: "-54",
                        x2: "125",
                        y2: "102",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#87B5FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#ADB5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var SteamIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "250",
        height: "135",
        viewBox: "0 0 250 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    filter: "url(#filter0_f_3619_22652)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M124.5 -64C135.991 -64 147.369 -61.7367 157.985 -57.3395C168.601 -52.9422 178.247 -46.497 186.372 -38.3718C194.497 -30.2467 200.942 -20.6008 205.339 -9.9848C209.737 0.631187 212 12.0093 212 23.5C212 46.7064 202.781 68.9624 186.372 85.3718C169.962 101.781 147.706 111 124.5 111C84.25 111 50.5625 84.05 40.15 47.3875L73.6625 61.2125C74.8154 66.8152 77.8639 71.8495 82.2946 75.4674C86.7252 79.0852 92.2674 81.0656 97.9875 81.075C111.638 81.075 122.75 69.9625 122.75 56.3125V55.175L152.5 33.9125H153.2C171.4 33.9125 186.188 19.125 186.188 0.925003C186.188 -17.275 171.4 -32.0625 153.2 -32.0625C135 -32.0625 120.125 -17.275 120.125 0.925003V1.3625L99.3875 31.6375L97.9875 31.55C92.825 31.55 88.0125 33.125 84.075 35.8375L37 16.5C40.7625 -28.5625 78.3875 -64 124.5 -64ZM91.95 68.7375C98.95 71.625 107 68.3875 109.887 61.3875C112.775 54.3875 109.45 46.425 102.625 43.5375L91.425 38.9C95.7125 37.325 100.525 37.2375 105.075 39.1625C109.712 41 113.3 44.5875 115.138 49.225C117.062 53.775 117.062 58.85 115.138 63.4C111.375 72.85 100.262 77.4 90.8125 73.4625C86.4375 71.625 83.1125 68.3 81.275 64.3625L91.95 68.7375ZM175.25 0.925003C175.25 13.0875 165.363 22.975 153.2 22.975C147.367 22.9519 141.781 20.6185 137.665 16.4858C133.549 12.3532 131.237 6.7579 131.238 0.925003C131.226 -1.9624 131.786 -4.82352 132.886 -7.49336C133.985 -10.1632 135.603 -12.5889 137.644 -14.6306C139.686 -16.6724 142.112 -18.2897 144.782 -19.3893C147.451 -20.4889 150.313 -21.0491 153.2 -21.0375C159.033 -21.0375 164.628 -18.7264 168.761 -14.6102C172.894 -10.4939 175.227 -4.90785 175.25 0.925003ZM136.75 0.925003C136.75 10.025 144.1 17.4625 153.287 17.4625C162.387 17.4625 169.738 10.025 169.738 0.925003C169.738 -8.175 162.387 -15.6125 153.287 -15.6125C144.1 -15.6125 136.75 -8.175 136.75 0.925003Z",
                        fill: "url(#paint0_linear_3619_22652)"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f_3619_22652",
                        x: "33",
                        y: "-68",
                        width: "183",
                        height: "183",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "2",
                                result: "effect1_foregroundBlur_3619_22652"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3619_22652",
                        x1: "124.5",
                        y1: "-64",
                        x2: "124.5",
                        y2: "111",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#87B5FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#ADB5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var MoreIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "250",
        height: "135",
        viewBox: "0 0 250 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    filter: "url(#filter0_f_3879_22562)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M124.5 -64C76.1759 -64 36.9998 -24.8239 36.9998 23.5C36.9998 71.8239 76.1759 111 124.5 111C172.824 111 212 71.8239 212 23.5C212 -24.8239 172.824 -64 124.5 -64ZM115.686 -0.880672C117.516 -4.48409 118.868 -6.19432 119.99 -7.08522C120.833 -7.75341 121.978 -8.31818 124.5 -8.31818C129.471 -8.31818 132.454 -4.57954 132.454 -0.538635C132.454 1.67273 132.025 2.77045 130.847 4.17046C129.201 6.12727 126.154 8.50569 120.125 12.4909L116.545 14.8455V31.4546C116.545 33.5642 117.383 35.5875 118.875 37.0793C120.367 38.571 122.39 39.4091 124.5 39.4091C126.609 39.4091 128.633 38.571 130.124 37.0793C131.616 35.5875 132.454 33.5642 132.454 31.4546V23.3648C136.766 20.3898 140.385 17.5421 143.01 14.4239C146.804 9.9216 148.363 5.11705 148.363 -0.538635C148.363 -12.2318 139.351 -24.2273 124.5 -24.2273C119.059 -24.2273 114.246 -22.8273 110.118 -19.558C106.268 -16.5114 103.643 -12.3193 101.495 -8.06364C100.996 -7.12923 100.689 -6.10456 100.591 -5.04974C100.493 -3.99493 100.607 -2.93122 100.926 -1.92105C101.245 -0.910873 101.763 0.0254135 102.448 0.832878C103.134 1.64034 103.974 2.30271 104.919 2.78112C105.864 3.25952 106.896 3.54432 107.952 3.6188C109.009 3.69328 110.07 3.55595 111.073 3.21486C112.076 2.87376 113.001 2.33579 113.793 1.6325C114.585 0.929207 115.229 0.0747681 115.686 -0.880672ZM132.454 59.2955C132.454 57.1858 131.616 55.1625 130.124 53.6708C128.633 52.179 126.609 51.3409 124.5 51.3409C122.39 51.3409 120.367 52.179 118.875 53.6708C117.383 55.1625 116.545 57.1858 116.545 59.2955V63.2727C116.545 65.3824 117.383 67.4057 118.875 68.8975C120.367 70.3892 122.39 71.2273 124.5 71.2273C126.609 71.2273 128.633 70.3892 130.124 68.8975C131.616 67.4057 132.454 65.3824 132.454 63.2727V59.2955Z",
                        fill: "url(#paint0_linear_3879_22562)"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f_3879_22562",
                        x: "32.9998",
                        y: "-68",
                        width: "183",
                        height: "183",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "2",
                                result: "effect1_foregroundBlur_3879_22562"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3879_22562",
                        x1: "124.5",
                        y1: "-64",
                        x2: "124.5",
                        y2: "111",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#87B5FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#ADB5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var items = [
    {
        title: "Discord",
        Icon: DiscordIcon
    },
    {
        title: "Email",
        Icon: EmailIcon
    },
    {
        title: "Twitter",
        Icon: TwitterIcon
    },
    {
        title: "Steam",
        Icon: SteamIcon
    },
    {
        title: "More to come",
        Icon: MoreIcon
    }, 
];
var VCPreview = function VCPreview() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap justify-center gap-3 w-[550px] sm:gap-6 sm:w-[80vw] mx-auto max-w-[1096px]",
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[146px] h-[76px] sm:w-[260px] sm:h-[135px] flex items-center justify-center rounded-lg bg-white sm:text-lg font-semibold relative border border-[rgb(183,208,255)] overflow-hidden",
                style: {
                    boxShadow: "2px 4px 14px rgba(60, 134, 251, 0.15)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute w-full h-full left-0 top-0 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.Icon, {
                            className: "w-full h-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "z-[2]",
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-1 -right-[2px] sm:top-3 sm:right-4 flex items-center justify-center bg-white rounded-[4px] px-1 py-[2px] z-[3] scale-[0.56] sm:scale-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_icons/* CoinIcon */.cL, {
                                className: "fill-primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[10px] ml-1",
                                children: "100"
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var homepage_VCPreview = (VCPreview);

;// CONCATENATED MODULE: ./src/components/homepage/MintIntro.tsx









var MintIntro = function() {
    var autoplay = (0,react.useRef)((0,embla_carousel_autoplay_esm/* default */.Z)({
        delay: 3000
    }));
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    (0,react.useEffect)(function() {
        setVisible(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[600px] sm:h-[860px]",
                style: {
                    background: "linear-gradient(180deg, rgba(221, 233, 252, 0.7) 50.7%, rgba(221, 233, 252, 0) 100%)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-full absolute left-0 top-0 flex items-center justify-center ".concat(visible ? "visible" : "invisible"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Carousel/* Carousel */.l, {
                            plugins: [
                                autoplay.current
                            ],
                            loop: true,
                            slideSize: "100%",
                            withIndicators: true,
                            onMouseEnter: autoplay.current.stop,
                            onMouseLeave: autoplay.current.reset,
                            classNames: {
                                indicators: "!-bottom-[30px] !gap-4",
                                indicator: "w-2 h-2 bg-[#E0E1E1] "
                            },
                            styles: {
                                indicator: {
                                    "&[data-active]": {
                                        backgroundColor: "#3C86FB"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel.Slide */.l.Slide, {
                                    className: "bg-center bg-no-repeat bg-contain bg-homeHeroBg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative flex flex-col items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_ClaimerNFTPreview, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-4 selection:text-fill-white font-extrabold text-[37px] sm:text-[80px] leading-none z-10",
                                                style: {
                                                    background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                                                    backgroundClip: "text",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                },
                                                children: "Karat ID"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "whitespace-pre-line sm:text-xl text-center mt-4 text-dark1 max-w-[95vw]",
                                                children: "Build your on-chain profile and name service"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-1 font-semibold sm:text-xl text-dark1",
                                                children: "Unlimited supply"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/mint/claimer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    className: "mt-12",
                                                    theme: "dark",
                                                    children: "Claim"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel.Slide */.l.Slide, {
                                    className: "bg-center bg-no-repeat bg-contain bg-idoBannerBg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative flex flex-col items-center overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/ido/rock.png",
                                                className: "-mt-10 sm:-mt-20 w-[550px] sm:w-[900px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " -mt-4 sm:-mt-12 selection:text-fill-white font-extrabold text-[37px] sm:text-[80px] leading-tight z-20",
                                                style: {
                                                    background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                                                    backgroundClip: "text",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                },
                                                children: "Mainnet token launch"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "whitespace-pre-line sm:text-xl text-center mt-4 text-dark1 max-w-[95vw] z-20",
                                                children: "70,000,000 KAT tokens available for mining"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/network/mining",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    className: "z-20 mt-12",
                                                    theme: "dark",
                                                    children: "Join Now"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel.Slide */.l.Slide, {
                                    className: "bg-center bg-no-repeat bg-contain bg-homeHeroBg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative flex flex-col items-center overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_VCPreview, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-8 selection:text-fill-white font-extrabold text-[37px] sm:text-[80px] leading-none z-10",
                                                style: {
                                                    background: "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                                                    backgroundClip: "text",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                },
                                                children: "Verifiable Credential"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "whitespace-pre-line sm:text-xl text-center mt-4 text-dark1 max-w-[95vw]",
                                                children: "Encrypt and verify your social accounts through MPC and bridge web2 data on chain"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/dashboard/credential",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    className: "mt-12",
                                                    theme: "dark",
                                                    children: "Verify"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap justify-between items-center pb-14 px-5 sm:pl-[110px] sm:pr-[80px] sm:pb-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 sm:mr-20 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-extrabold text-[36px] text-dark2",
                                children: "What’s Karat Network"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 text-dark1 text-lg min-w-[330px]",
                                children: "A fully decentralized data network that connects Web2 to Web3. Powered by MPC and ZK technologies."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* Button */.z, {
                                variant: "outline",
                                radius: "xl",
                                size: "md",
                                classNames: {
                                    root: "mt-6 w-[149px]"
                                },
                                onClick: function() {
                                    window.open("https://docs.karatdao.com/karat-network", "_blank");
                                },
                                children: "Learn More"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/network/network-group.png",
                        className: "flex-shrink mt-10 sm:mt-0 w-[477px]"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_MintIntro = (MintIntro);

// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/services/network/index.ts
var network = __webpack_require__(4600);
;// CONCATENATED MODULE: ./src/components/homepage/NetworkData.tsx




var NetworkData = function() {
    var ref = (0,react.useState)(), networkInfo = ref[0], setNetworkInfo = ref[1];
    var ref1 = (0,react.useState)([]), items = ref1[0], setItems = ref1[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        setItems([
            {
                label: "Claimer Minted",
                value: "".concat((0,format/* numberWithCommas */.x6)((ref = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.claimerMinted) !== null && ref !== void 0 ? ref : 0), "+")
            },
            {
                label: "VC Minted",
                value: "".concat((0,format/* numberWithCommas */.x6)((ref1 = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.vcMinted) !== null && ref1 !== void 0 ? ref1 : 0), "+")
            },
            {
                label: "Karat IDs Created",
                value: "".concat((0,format/* numberWithCommas */.x6)((ref2 = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.karatIDCreated) !== null && ref2 !== void 0 ? ref2 : 0), "+")
            }, 
        ]);
    }, [
        networkInfo
    ]);
    (0,react.useEffect)(function() {
        (0,network/* getNetworkInfo */.yj)().then(setNetworkInfo);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "layout-block layout-content px-16 pb-[100px] sm:py-10 sm:px-12 font-exo",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-around flex-wrap gap-14",
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[48px] font-extrabold text-tertiary",
                                children: item.value
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 text-[28px] font-light text-dark1",
                                children: item.label
                            })
                        ]
                    }, index)
                });
            })
        })
    });
};
/* harmony default export */ var homepage_NetworkData = (NetworkData);

;// CONCATENATED MODULE: ./src/pages/index.tsx
















var Home = function() {
    var height = (0,esm/* use100vh */.g)();
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var hash = window.location.hash.slice(1);
        if (hash) {
            var target = document.getElementById("".concat(hash, "-anchor"));
            if (target) {
                target.scrollIntoView({
                    block: "start",
                    behavior: "smooth"
                });
            }
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "container",
        style: {
            height: height ? "".concat(height, "px") : "100vh"
        },
        className: "w-screen overflow-x-hidden overflow-y-scroll bg-white font-exo",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_MintIntro, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_FeaturesIntro, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_DataOwnship, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_Partners, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_ChooseRole, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_NetworkData, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_Mission, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_FormIntro, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_Investors, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-dark1 text-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "layout-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Footer, {})
                })
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 4600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ getValidatorAirdropClaimInfo; },
/* harmony export */   "LC": function() { return /* binding */ getVestingClaimInfo; },
/* harmony export */   "QO": function() { return /* binding */ getAirdropClaimInfo; },
/* harmony export */   "t9": function() { return /* binding */ getRefereesTable; },
/* harmony export */   "yj": function() { return /* binding */ getNetworkInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6293);



var getRefereesTable = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!data.character || typeof data.validatorTokenId === "undefined") {
                        return [
                            2,
                            {
                                list: [],
                                pageSize: 0,
                                pageNum: 0,
                                size: 0,
                                next: 0,
                                total: 0,
                                pages: 0
                            }
                        ];
                    }
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getRefereesTable", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getRefereesTable(data) {
        return _ref.apply(this, arguments);
    };
}();
var getNetworkInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getNetworkInfo", {})
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getNetworkInfo() {
        return _ref.apply(this, arguments);
    };
}();
var getVestingClaimInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getVestingClaimInfo", data)
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getVestingClaimInfo(data) {
        return _ref.apply(this, arguments);
    };
}();
var getAirdropClaimInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getAirdropClaimInfo", data)
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAirdropClaimInfo(data) {
        return _ref.apply(this, arguments);
    };
}();
var getValidatorAirdropClaimInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getValidatorAirdropClaimInfo", data)
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getValidatorAirdropClaimInfo(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3454,2280,6034,7258,4304,8342,7172,2256,7356,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);